__turbopack_context__.v({
  "emptyIcon": "mediaGallery-module-scss-module__ukkXjW__emptyIcon",
  "emptyPlaceholder": "mediaGallery-module-scss-module__ukkXjW__emptyPlaceholder",
  "emptyText": "mediaGallery-module-scss-module__ukkXjW__emptyText",
  "gallery": "mediaGallery-module-scss-module__ukkXjW__gallery",
  "galleryEmpty": "mediaGallery-module-scss-module__ukkXjW__galleryEmpty",
  "galleryGrid": "mediaGallery-module-scss-module__ukkXjW__galleryGrid",
  "galleryMain": "mediaGallery-module-scss-module__ukkXjW__galleryMain",
  "galleryMainTiled": "mediaGallery-module-scss-module__ukkXjW__galleryMainTiled",
  "galleryModalClose": "mediaGallery-module-scss-module__ukkXjW__galleryModalClose",
  "galleryModalContent": "mediaGallery-module-scss-module__ukkXjW__galleryModalContent",
  "galleryModalCount": "mediaGallery-module-scss-module__ukkXjW__galleryModalCount",
  "galleryModalDisplay": "mediaGallery-module-scss-module__ukkXjW__galleryModalDisplay",
  "galleryModalMain": "mediaGallery-module-scss-module__ukkXjW__galleryModalMain",
  "galleryModalMedia": "mediaGallery-module-scss-module__ukkXjW__galleryModalMedia",
  "galleryModalNav": "mediaGallery-module-scss-module__ukkXjW__galleryModalNav",
  "galleryModalOverlay": "mediaGallery-module-scss-module__ukkXjW__galleryModalOverlay",
  "galleryModalThumb": "mediaGallery-module-scss-module__ukkXjW__galleryModalThumb",
  "galleryModalThumbActive": "mediaGallery-module-scss-module__ukkXjW__galleryModalThumbActive",
  "galleryModalThumbnailStrip": "mediaGallery-module-scss-module__ukkXjW__galleryModalThumbnailStrip",
  "galleryModalThumbnails": "mediaGallery-module-scss-module__ukkXjW__galleryModalThumbnails",
  "gallerySidebar": "mediaGallery-module-scss-module__ukkXjW__gallerySidebar",
  "gallerySingleItem": "mediaGallery-module-scss-module__ukkXjW__gallerySingleItem",
  "galleryThreeItem": "mediaGallery-module-scss-module__ukkXjW__galleryThreeItem",
  "galleryTwoItem": "mediaGallery-module-scss-module__ukkXjW__galleryTwoItem",
  "gridImage": "mediaGallery-module-scss-module__ukkXjW__gridImage",
  "halfImage": "mediaGallery-module-scss-module__ukkXjW__halfImage",
  "lightboxClose": "mediaGallery-module-scss-module__ukkXjW__lightboxClose",
  "lightboxContent": "mediaGallery-module-scss-module__ukkXjW__lightboxContent",
  "lightboxMedia": "mediaGallery-module-scss-module__ukkXjW__lightboxMedia",
  "lightboxOverlay": "mediaGallery-module-scss-module__ukkXjW__lightboxOverlay",
  "mainImage": "mediaGallery-module-scss-module__ukkXjW__mainImage",
  "mainImageContain": "mediaGallery-module-scss-module__ukkXjW__mainImageContain",
  "mediaImage": "mediaGallery-module-scss-module__ukkXjW__mediaImage",
  "mediaItem": "mediaGallery-module-scss-module__ukkXjW__mediaItem",
  "playIcon": "mediaGallery-module-scss-module__ukkXjW__playIcon",
  "showAllButton": "mediaGallery-module-scss-module__ukkXjW__showAllButton",
  "sidebarImage": "mediaGallery-module-scss-module__ukkXjW__sidebarImage",
  "singleImage": "mediaGallery-module-scss-module__ukkXjW__singleImage",
  "videoOverlay": "mediaGallery-module-scss-module__ukkXjW__videoOverlay",
});
